<template>
  <v-content>
    <section id="cover">
      <div class="section-contents">
        <h1>STORE</h1>
        <p>전국에 위치한 더브라운 매장에서 고객님을 기다립니다</p>
      </div>
    </section>
    <section id="search">
      <div class="wrapper">
        <div class="search-title">
          <h2>전국의 더브라운 매장을 찾아보세요</h2>
        </div>
        <ul class="search-body">
          <li class="sido">
            <span class="label">지역별</span>
            <v-select
              v-model="selectCity"
              class="sido"
              :items="cityList"
            ></v-select>
          </li>
          <li class="text">
            <span class="label">매장명</span>
            <!-- <v-text-field
              label="매장명을 검색하세요"
              single-line
              append-icon="keyboard_arrow_right"
            ></v-text-field> -->
            <v-text-field
              placeholder=""
              hint="매장명을 입력하세요"
              single-line
              append-icon="mdi-check"
              v-model="inputStoreName"
              clearable
            ></v-text-field>
          </li>
          <li class="service">

            <span class="label">서비스별</span>
            <div
              @click="selectWifi = !selectWifi"
              :class="['search-icon', 'wifi', selectWifi ? 'active' : '']"
            ></div>
            <div
              @click="selectAllday = !selectAllday"
              :class="['search-icon', 'allday',selectAllday ? 'active' : '']"
            ></div>
            <div
              @click="selectParking = !selectParking"
              :class="['search-icon', 'parking',selectParking ? 'active' : '']"
            ></div>
            <div
              @click="selectTerrace = !selectTerrace"
              :class="['search-icon', 'terrace',selectTerrace ? 'active' : '']"
            ></div>
          </li>
        </ul>
      </div>
    </section>
    <section id="store-list">
      <v-container
        grid-list-lg
        contents
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            md4
            xs12
          >
            <v-card
              color="#eeedec"
              tile
              elevation="0"
              class="over-hidden map-chart"
            >
              <p>
                지도에서 해당 지역에 있는 <br />
                더브라운 매장을 찾아보세요
              </p>
              <div class="store-mapchart">
                <!-- 이곳에 차트를 넣으시면 됩니다 <img> 주석처리 or 삭제 부탁드립니다. -->
                <div class="map">
                  <div
                    id="pt-ICN"
                    class="wrap"
                    style="top:85px; left:-65px; "
                  >
                    <div
                      :class="['icon',cityList.includes('인천') ? '': 'disable', selectCity==='인천' ? 'active' : '' ]"
                      @click="selectCity='인천'"
                    ></div>
                    <div class="map-info">
                      <p><span>{{CountGroupByCity['인천']|| 0}}</span>EA</p>
                      <h3>인천광역시</h3>
                    </div>
                  </div>
                  <div
                    id="pt-SEO"
                    class="wrap"
                    style="top:40px; left:-34px;"
                  >
                    <div
                      :class="['icon',cityList.includes('서울') ? '': 'disable', ['서울', '전체'].includes(selectCity) ? 'active' : '' ]"
                      @click="selectCity='서울'"
                    ></div>
                    <div class="map-info">
                      <p><span>{{CountGroupByCity['서울']|| 0}}</span>EA</p>
                      <h3>서울특별시</h3>
                    </div>
                  </div>
                  <div
                    id="pt-GGD"
                    class="wrap"
                    style="top:93px; left:-25px;"
                  >
                    <div
                      :class="['icon', cityList.includes('경기') ? '': 'disable', selectCity==='경기' ? 'active' : '' ]"
                      @click="selectCity='경기'"
                    ></div>
                    <div class="map-info">
                      <p><span>{{CountGroupByCity['경기']|| 0}}</span>EA</p>
                      <h3>경기도</h3>
                    </div>
                  </div>
                  <div
                    id="pt-GWD"
                    class="wrap"
                    style="top:69px; left:50px;"
                  >
                    <div :class="['icon', cityList.includes('강원') ? '': 'disable',selectCity==='강원' ? 'active' : ''  ]"></div>
                  </div>
                  <div
                    id="pt-CND"
                    class="wrap"
                    style="top:150px; left:-40px;"
                  >
                    <div
                      :class="['icon', cityList.includes('충남') ? '': 'disable',selectCity==='충남' ? 'active' : ''  ]"
                      @click="selectCity='충남'"
                    ></div>
                    <div class="map-info">
                      <p><span>{{CountGroupByCity['충남']|| 0}}</span>EA</p>
                      <h3>충청남도</h3>
                    </div>
                  </div>
                  <div
                    id="pt-CBD"
                    class="wrap"
                    style="top:121px; left:8px;"
                  >
                    <div :class="['icon', cityList.includes('충북') ? '': 'disable',selectCity==='충북' ? 'active' : ''  ]"></div>
                  </div>
                  <div
                    id="pt-ULS"
                    class="wrap"
                    style="top:230px; left:94px;"
                  >
                    <div
                      :class="['icon', cityList.includes('울산') ? '': 'disable',selectCity==='울산' ? 'active' : ''  ]"
                      @click="selectCity='울산'"
                    ></div>
                    <div class="map-info right">
                      <p><span>{{CountGroupByCity['울산']|| 0}}</span>EA</p>
                      <h3>울산광역시</h3>
                    </div>
                  </div>
                  <div
                    id="pt-JBD"
                    class="wrap"
                    style="top:227px; left:-20px;"
                  >
                    <div :class="['icon', cityList.includes('전북') ? '': 'disable',selectCity==='전북' ? 'active' : ''  ]"></div>
                  </div>
                  <div
                    id="pt-DGG"
                    class="wrap"
                    style="top:230px; left:50px;"
                  >
                    <div
                      :class="['icon', cityList.includes('대구') ? '': 'disable',selectCity==='대구' ? 'active' : ''  ]"
                      @click="selectCity='대구'"
                    ></div>
                    <div class="map-info right">
                      <p><span>{{CountGroupByCity['대구'] || 0}}</span>EA</p>
                      <h3>대구광역시</h3>
                    </div>
                  </div>
                  <div
                    id="pt-BSN"
                    class="wrap"
                    style="top:270px; left:90px;"
                  >
                    <div
                      :class="['icon', cityList.includes('부산') ? '': 'disable',selectCity==='부산' ? 'active' : ''  ] "
                      @click="selectCity='부산'"
                    ></div>
                    <div class="map-info right">
                      <p><span>{{CountGroupByCity['부산'] || 0}}</span>EA</p>
                      <h3>부산광역시</h3>
                    </div>
                  </div>
                  <div
                    id="pt-GNJ"
                    class="wrap"
                    style="top:270px; left:-60px;"
                  >
                    <div :class="['icon', cityList.includes('광주') ? '': 'disable',selectCity==='광주' ? 'active' : ''  ]"></div>
                    <div class="map-info">
                      <p><span>{{CountGroupByCity['광주'] || 0}}</span>EA</p>
                      <h3>광주광역시</h3>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex
            md8
            xs12
          >
            <v-card
              color="#eeedec"
              tile
              elevation="0"
              class="over-hidden map-table"
            >
              <p>
                지역별 더브라운 매장 안내입니다
              </p>
              <v-data-table
                :headers="headers"
                :items="filteredList"
                class="store-table"
                hide-actions
                item-key="name"
                no-data-text="없습니다"
                ref="tableBody"
              >
                <!-- <template v-slot:headers="props">
                  <tr>
                    <th
                      class="header-style"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', 'text-xs-' + header.align]"
                      @click="changeSort(header.value)"
                    >
                      {{ header.text }}
                      <v-icon small>keyboard_arrow_up</v-icon>
                    </th>
                  </tr>
                </template> -->
                <template v-slot:items="props">
                  <!-- {{props.index === 0 ? (props.expanded = true)?'':'' : (props.expanded=false)?'':''}} -->
                  <tr
                    @click="props.expanded = !props.expanded"
                    :ref="props.item.id"
                    style="cursor: pointer;"
                  >
                    <!-- 제일 첫줄 첫 컬럼에 스타일이 안먹히는 버그 -->
                    <td
                      class="text-xs-left"
                      style="vertical-align: middle; font-size: 16px !important;"
                    >{{ props.item.city }}</td>
                    <td class="text-xs-left font-weight-bold">{{ props.item.name }}</td>
                    <td class="text-xs-left">{{ props.item.address }}</td>
                    <td class="text-xs-center">
                      <div class="td-wrap">
                        <div
                          v-if="props.item.services.wifi"
                          class="search-icon wifi sm"
                        ></div>
                        <div
                          v-if="props.item.services.allday"
                          class="search-icon allday sm"
                        ></div>
                        <div
                          v-if="props.item.services.parking"
                          class="search-icon parking sm"
                        ></div>
                        <div
                          v-if="props.item.services.terrace"
                          class="search-icon terrace sm"
                        ></div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="props">
                  <v-card
                    flat
                    color="#eeedec"
                    height="350"
                    class="store-desc"
                  >
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex
                        md3
                        xs12
                        class="desc-text"
                      >
                        <p>
                          <span>운영시간</span><br />{{props.item.opTime}}<br />
                          <span>연락처</span><br /> {{props.item.phone}}<br />
                        </p>
                        <div>
                          <!-- <p class="font-weight-bold">매장사진</p> -->
                          <div class="store-image"></div>
                        </div>
                      </v-flex>
                      <v-flex
                        md9
                        xs12
                        class="desc-map"
                      >
                        <vue-daum-map
                          :appKey="appKey"
                          :center.sync="props.item.coord"
                          :level.sync="level"
                          :mapTypeId="mapTypeId"
                          :libraries="libraries"
                          @load="onLoadMap"
                          style="width:100%;height:100%; border: 1px solid"
                        >
                        </vue-daum-map>

                        <!-- <v-img
                          aspect-ratio="1.8"
                          cover
                          src="images/map-store.png"
                          alt=""
                        > </v-img> -->
                      </v-flex>
                    </v-layout>
                  </v-card>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </v-content>

</template>
<script>
import _ from 'lodash'
import axios from 'axios'
import VueDaumMap from 'vue-daum-map'
export default {
  components: {
    VueDaumMap
  },
  created () {
    this.$nextTick(async () => {
      // console.log('created!', this.storeList)
      this.storeList = await axios.get(document.api_host + '/stores.json')
        .then(({ data }) => {
          return data
        })
        .catch(err => console.error('no data ( data fetch error )'))
      this.cityList = this.getCityList()
    })
  },
  mounted () {
    const queryName = this.$route.query.name
    if (queryName) {
      this.inputStoreName = queryName
    }


  },
  data () {
    return {
      appKey: '2d7669180ac31733144cc09adde034c0', // 테스트용 appkey
      // center: { lat: 33.450701, lng: 126.570667 }, // 지도의 중심 좌표
      level: 3, // 지도의 레벨(확대, 축소 정도),
      mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
      libraries: ['drawing'], // 추가로 불러올 라이브러리
      map: null, // 지도 객체. 지도가 로드되면 할당됨.
      pagination: {
        sortBy: 'city'
      },
      headers: [
        {
          text: '지역명',
          value: 'city',
          align: 'left'
        },
        { text: '매장명', value: 'name', align: 'left' },
        { text: '매장주소', value: 'address', align: 'left' },
        { text: '지원 서비스', value: 'services', align: 'center' }
      ],
      cityList: [],
      selectCity: '전체',
      inputStoreName: '',
      selectWifi: false,
      selectParking: false,
      selectTerrace: false,
      selectAllday: false,
      tableKey: 0,
      storeList: [
      ]
    }
  },
  watch: {
  },
  methods: {
    getCityList () {
      let list = ['전체']
      return list.concat(Array.from(new Set(this.storeList.map(e => e.city))))
    },
    loadProp (prop) {
      console.log(prop)
      return prop
    },
    onLoadMap (map) {
      const imageSrc = require('../assets/images/store-marker.png') // 마커이미지의 주소입니다
      const imageSize = new kakao.maps.Size(60, 60) // 마커이미지의 크기입니다
      const imageOption = { offset: new kakao.maps.Point(30, 50) } // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

      // 마커의 이미지정보를 가지고 있는 마커이미지를 생성합니다
      var markerImage = new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption)

      // 마커가 표시될 위치입니다
      const markerPosition = map.getCenter();
      // // 마커를 생성합니다
      const marker = new kakao.maps.Marker({
        position: markerPosition,
        image: markerImage // 마커이미지 설정
      });
      // 마커가 지도 위에 표시되도록 설정합니다
      marker.setMap(map);
    },
    changeSort (column) {
      console.log(column)
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    getCountGroupByCity () {
      const l = _.countBy(this.filteredList, 'city')
      return l
    },
  },
  computed: {
    filteredList () {
      // console.log('filtered', this.storeList)
      let f = this.storeList.slice(0)
      if (this.selectCity !== '전체') {
        f = f.filter(store => (store.city === this.selectCity))
      }
      if ((this.inputStoreName || '').length > 1) {
        f = f.filter(store => store.name.includes(this.inputStoreName))
      }

      if (this.selectWifi || this.selectParking || this.selectTerrace || this.selectAllday) {
        if (this.selectWifi) f = f.filter(store => store.services.wifi)
        if (this.selectTerrace) f = f.filter(store => store.services.terrace)
        if (this.selectAllday) f = f.filter(store => store.services.allday)
        if (this.selectParking) f = f.filter(store => store.services.parking)
      }
      return f
    },
    CountGroupByCity () {
      const l = _.countBy(this.filteredList, 'city')
      return l
    }

  },

}
</script>

<style lang="css" scoped>
/* section */
#cover {
  background-image: url("/images/store-cover.jpg");
  /* background-size: auto 570px; */
  margin-top: 130px;
  background-attachment: fixed;
  background-position: 0px 130px;
  background-repeat: repeat-x;
  width: 100%;
  height: 470px;
  color: #ffffff;
}

#cover div.section-contents {
  margin: 0px auto;
}

#cover h1 {
  font-family: "europa";
  flex-basis: 33.33%;
  font-size: 70px;
  font-weight: 600;
  /* letter-spacing: -3px; */
}
#cover p {
  font-family: "NanumSquare";
  padding-top: 20px;
  font-weight: 600;
  flex-basis: 66.66%;
  font-size: 20px;
}
#search {
  padding: 40px 40px 0px 40px;
  width: 100%;
  height: 200px;
  color: #686059;
}
#search div.wrapper {
  max-width: 1420px;
  margin: 0px auto;
  border-bottom: 5px solid #686059;
  padding-bottom: 20px;
}
#search .search {
}

.v-content__wrap {
  background-color: #eeedec;
}

#search .search-title > h2 {
  font-weight: 900;
  font-size: 20px;
}
#search ul.search-body {
  display: flex;
  padding: 0px;
}
#search ul.search-body > li {
  /* border: 2px solid tomato; */
  display: block;
  flex-basis: 33.33%;
  display: flex;
  align-items: center;
  padding: 0px 10px;
}
#search ul.search-body > li span {
  margin: 0px 10px;
  font-weight: 900;
  font-size: 20px;
  display: block;
  min-width: 55px;
}

#search ul.search-body > li:before {
  display: inline-table;
  content: "|";
  font-size: 40px;
  font-weight: 200;
}
#search ul.search-body > li:first-child::before {
  content: "";
}
#search ul.search-body > li.text {
  padding-left: 0px;
}
#search ul.search-body > li.text > span {
  margin-left: 0px;
}
#search ul.search-body > li.text > span.label {
  margin-left: 10px;
}
#search ul.search-body > li.service > div.search-icon {
  flex: 1;
  height: 60px;
}

div.search-icon {
  background-size: 40px 40px;
  background-position: center center;
  transition: all 0.4s;
}
div.search-icon:hover {
  transform: scale(1.4);
  cursor: pointer;
}

div.search-icon.wifi {
  background-image: url("../assets/images/wifi.svg");
}
div.search-icon.wifi.active {
  background-image: url("../assets/images/wifi-active.svg");
}
div.search-icon.allday {
  background-image: url("../assets/images/allday.svg");
}
div.search-icon.allday.active {
  background-image: url("../assets/images/allday-active.svg");
}
div.search-icon.parking {
  background-image: url("../assets/images/parking.svg");
}
div.search-icon.parking.active {
  background-image: url("../assets/images/parking-active.svg");
}
div.search-icon.terrace {
  background-image: url("../assets/images/terrace.svg");
}
div.search-icon.terrace.active {
  background-image: url("../assets/images/terrace-active.svg");
}

#store-list {
  width: 100%;
  padding: 0px 20px;
}
#store-list .contents {
  max-width: 1468px !important;
  padding-top: 0px !important;
}

#store-list .over-hidden {
  overflow: hidden;
}

#store-list .map-chart,
.map-table > p {
  font-weight: 900;
  font-size: 20px;
  color: #686059;
}
#store-list .store-mapchart {
  flex: 1;
  min-width: 280px;
  /* max-width: 380px; */
  height: 500px;
  /* flex-basis: 400px; */
  /* padding-left: 40px; */
  position: relative;
  /* border: 2px solid red; */
  /* background-color: tomato; */
}
#store-list .store-mapchart .map-info {
  /* position: absolute;
  top: 80px; */
  /* color: #fecba0 !important ; */
}

#store-list .map-info {
  pointer-events: none;
  z-index: 100;
  width: 110px;
  height: 30px;
  top: 10px;
  left: 5px;
  /* background-color: #777; */
  /* background-repeat: no-repeat; */
  /* background-image: url('../assets/images/map-info-line.svg'); */
  /* background-size: 115px auto;
  background-position: 0px 10px; */
  position: absolute;
  /* color: #fdcaa3; */
  color: #b5774f;
  text-shadow: 2px 2px 3px #ddd;
  /* display: none; */
  opacity: 0;
}
#store-list .map-info.right {
  top: 0px;
  left: 110px;
  margin-left: 27px;
  transform: scaleX(-1);
}
#store-list .map-info p {
  margin-top: -55px;
  font-family: "europa";
  font-weight: 600;
  font-size: 18px;
  /* border: 2px solid red; */
  background-image: url("../assets/images/map-info-line.svg");
  background-size: 115px auto;
  background-position: 0px 60px;
  /* margin-bottom: 0px;
  border-bottom: 3px solid#d5c0af;
  border-right: 3px solid#d5c0af;
  border-radius: 0 0 30px 0 / 0 0 30px 0;
  */
}
/* Array.from(t).map( tr => Array.from(tr.children) ).map(tdList => ({name: tdList[0].innerText , city: tdList[1].innerText, address: tdList[2].innerText , services: tdList[3].children[0].children })) */
#store-list .map-info.right p {
  /* margin-left: 100px; */
  text-align: right;
  margin-top: -40px;
  padding-left: 30px;
  transform: scaleX(-1);
  background-image: url("../assets/images/map-info-line-right.svg");
  background-size: 115px auto;
  background-position: 0px 60px;
  /* border-bottom: 2px solid#d5c0af; */
}
#store-list .map-info h3 {
  font-size: 16px;
  position: absolute;
  top: 40px;
}
#store-list .map-info.right h3 {
  padding-left: 10px;
  transform: scaleX(-1);
  /* border-bottom: 2px solid#d5c0af; */
}
#store-list .store-mapchart {
  margin-top: 40px;
}
#store-list .store-mapchart p span {
  font-size: 60px;
}

#store-list .store-mapchart .map {
  margin: 1px auto;
  width: 280px;
  height: 100%;
  position: relative;
  background-image: url("../assets/images/map-background-store.png");
  background-size: contain;
  background-repeat: no-repeat;
  /* border: 2px solid white; */
}

#store-list .store-mapchart div.wrap {
  width: 30px;
  height: 30px;
  position: absolute;
  /* border: 3px solid blue; */
}

#store-list .store-mapchart .icon {
  /* border: 1px solid green; */
  width: 30px;
  height: 30px;
  background-image: url("../assets/images/store-map-default.svg");
  background-size: contain;
  left: 110px;
  position: absolute;
  transition: all 0.3s ease-in;
}

#store-list .store-mapchart .icon.disable {
  /* border: 1px solid green; */
  background-image: url("../assets/images/store-map-disable.svg");
  background-size: contain;
  left: 110px;
  position: absolute;
}
#store-list .store-mapchart div.wrap .icon.active {
  background-image: url("../assets/images/store-map-active.svg");
  animation-name: move;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}
@keyframes move {
  /* keyframe */

  0% {
    transform: scale(1.3);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.3);
  }
}

#store-list .store-mapchart div.wrap .icon.active + .map-info {
  opacity: 1;
  transition: all 0.3s ease-in;
}

#store-list .store-mapchart div.wrap > div:not(.disable):hover {
  transform: scale(1.3);
  background-image: url("../assets/images/store-map-active.svg");
  cursor: pointer;
}
#store-list div.map-table > p {
  margin-bottom: 40px;
}
#store-list .store-mapchart div.wrap > div:not(.disable):hover + .map-info {
  opacity: 1;
  transition: all 0.3s ease-in;
}
#store-list .map-table .store-table .v-datatable tr {
  /* display: flex;
  flex-wrap: wrap;
  height: initial; */
  /* height: 60px; */
  transition: all 0.4s;
}

#store-list .map-table .store-table table.v-datatable tr th,
td {
  /* display: flex;
  align-items: center;
  justify-content: center; */
  padding: 0px 0px;
  word-break: keep-all;
  height: 60px;
  vertical-align: middle;
}

#store-list .map-table .store-table .v-datatable thead tr:first-child {
  border-bottom: 2px solid #686059;
}

#store-list .map-table .store-table .v-datatable tbody tr:not(:first-child) {
  border-top: 1px solid #686059;
}

#store-list .map-table .store-table .v-datatable tr:nth-child(odd) td {
  /* background: #e5e5e5; */
}

/* #store-list .map-table .store-table .v-datatable tr th {
  font-weight: 900;
  font-size: 20px;
  color: #686059;
} */

#store-list .map-table .store-table .v-datatable tr td {
  padding: 10px 0px;
  font-size: 16px !important;
}
/*
#store-list .map-table .store-table .v-datatable tr th:nth-child(1),
td:nth-child(1) {
  flex-basis: 10%;
  order: 1;
}
#store-list .map-table .store-table .v-datatable tr th:nth-child(2),
td:nth-child(2) {
  flex-basis: 20%;
  order: 2;
}
#store-list .map-table .store-table .v-datatable tr th:nth-child(3),
td:nth-child(3) {
  flex-basis: 55%;
  order: 2;
}
#store-list .map-table .store-table .v-datatable tr th:nth-child(4),
td:nth-child(4) {
  flex-basis: 15%;
  order: 4;
} */
div.sm {
  background-size: 24px 24px;
}
div.td-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
}

div.td-wrap > div {
  width: 24px;
  height: 24px;
}

.store-desc div.desc-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 30px !important;
  padding-bottom: 0px !important;

  /* border: 2px solid red; */

  /* padding-left: 20px; */
  /* font-size: 16px;
  font-weight: 400; */
}
.store-desc div.desc-text p > span {
  font-weight: 600;
}
.store-desc div.desc-text div > p {
  margin-bottom: 10px !important;
}

.store-desc div.store-image {
  /* margin-left: 20px; */
  width: 200px;
  height: 120px;
  /* background-color: red; */
  /* background-size: cover; */
}
.store-desc div.desc-map {
  padding: 30px 10px 0px 30px !important;

  display: flex;
  justify-content: flex-end;
  /* border: 2px solid red; */

  /* padding-left: 20px; */
  /* font-size: 16px;
  font-weight: 400; */
}

/* .store-desc div.store-map img{
  position: absolute; top:0; left: 0;
  width: 100%;
  height: 100%;
} */
/* .v-responsive__content:hover ~ .v-image__image {
  transform: scale(1.3);
} */

@media (max-width: 1023px) {
  #cover {
    margin-top: 80px;
    height: 220px;
    background-size: auto 220px;
    background-position-y: 80px;
    background-position-x: left;
  }
  #cover .section-contents {
    padding: 20px;
    display: flex;
    flex-direction: column;
  }
  #cover h1 {
    font-size: 40px;
  }
  #cover p {
    padding: 0px;
    max-width: 260px;
    font-size: 18px;
    /* display: none; */
  }
  #search {
    padding: 20px 20px 0px 20px;

    height: auto;
  }

  #search div.wrapper {
    padding-bottom: 10px;
  }
  #search div.search-title {
    margin-bottom: 15px;
  }
  #search h2 {
    font-size: 18px;
  }

  #search ul.search-body {
    flex-direction: column;
  }

  #search ul.search-body li:nth-child(1) {
    display: none;
  }
  #search ul.search-body li {
    max-height: 65px;
    padding: 0px;
  }
  #search ul.search-body li span {
    margin-left: 0px;
    font-size: 18px;
  }
  #search ul.search-body > li:before {
    content: "";
  }

  #store-list .contents {
    padding: 0px 0px !important;
  }
  #store-list .map-chart {
    display: none;
  }

  #store-list
    .map-table
    .store-table
    .v-datatable
    tr.v-datatable__expand-row
    > td
    div.flex.desc-map {
    display: none;
  }
  #store-list
    .map-table
    .store-table
    .v-datatable
    tr.v-datatable__expand-row
    > td
    div.flex.desc-text
    > div {
    display: none;
  }

  #store-list
    .map-table
    .store-table
    .v-datatable
    tr.v-datatable__expand-row
    > td
    div.store-desc {
    height: 150px !important;
  }
  #store-list .map-table .store-table table.v-datatable tr th {
    font-size: 16px;
  }

  /* #store-list .map-table .store-table .v-datatable thead {
    display: none;
  }  ==> common.css scoped 에서 씹힘 */

  #store-list
    .map-table
    .store-table
    .v-datatable
    tr.v-datatable__expand-row
    > td
    div.flex.desc-text
    > p {
    font-size: 14px !important;
  }
}
</style>